function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/*
 * @Author: lijianzhang
 * @Date: 2018-10-28 20:31:24
 * @Last Modified by: 天吾
 * @Last Modified time: 2019-07-11 16:48:28
 */
import sha1 from 'crypto-js/sha1';
import Event from 'eventemitter3';
import merge from 'lodash/merge';
import isEqual from 'lodash/isEqual';
import debounce from 'lodash/debounce'; // udesk 配置信息

var imUserKey = '5f4ccb0eae5588fe36c8f8c797bd83fe';
var code = '2fc6j4ag';
var link = 'https://ttxsapp.udesk.cn/im_client/?web_plugin_id=52568';
var windowloaded = false;
/**
 * 确保 udesk iframe 在 页面 load 之后加载
 *
 * @returns
 */

function onWindowLoad() {
  if (process.env.SERVER) return;
  return new Promise(function (resolve) {
    if (windowloaded) return resolve();

    function onLoad() {
      windowloaded = true;
      window.removeEventListener('load', onload);
      resolve();
    }

    if (window) {
      window.addEventListener('load', onLoad);
    }
  });
}

onWindowLoad();
/**
 * 封装了 udesk 的使用方式
 *
 * @class Udesk
 * @extends {Event}
 */

var Udesk = /*#__PURE__*/function (_Event) {
  _inherits(Udesk, _Event);

  var _super = _createSuper(Udesk);

  function Udesk() {
    var _this;

    _classCallCheck(this, Udesk);

    _this = _super.call(this); // 当前应该显示的文本, 会根据客服是否上线而变化

    _this.label = ''; // 唯独消息的数目

    _this.unread = 0;
    _this.config = null;
    _this.panelStyle = {};
    _this.firstShow = true;
    _this.isShow = false;
    _this.lastConfig = null;
    _this.setConfig = debounce(_this._setConfig.bind(_assertThisInitialized(_this)), 1000, {
      trailing: true
    });
    return _this;
  }
  /**
   * 获取随机字符串
   */


  _createClass(Udesk, [{
    key: "getNonce",
    value: function getNonce(num) {
      var s = '';

      while (s.length < num) {
        var n = Math.floor(Math.random() * 62);
        if (n < 10) s += n;else if (n < 36) s += String.fromCharCode(n + 55); // AZ
        else s += String.fromCharCode(n + 61); // az
      }

      return s;
    }
    /**
     *
     *
     * @param {} config
     * @param string config.code - udesk配置信息
     * @param string config.link - udesk配置信息
     * @param string config.onlineText - 客服在线显示文本，默认为 **udesk管理台配置文案**
     * @param string config.offlineText - 客服在线显示文本，默认为 **客服离线显示文本 **udesk管理台配置文案**
     * @param {[string]: string} config.css  style - 按钮样式
     * @param {}  config.panel - 聊天面板
     * @param {} config.customer  - 客户信息 [参考](http://www.udesk.cn/doc/thirdparty/webim/#_11)
     * @param {title: string; url: string; image: string, <自定义参数>: string}  config.product - 客户信息 [参考](http://www.udesk.cn/doc/thirdparty/webim/#_11)
     */

  }, {
    key: "_setConfig",
    value: function _setConfig() {
      var _this2 = this;

      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (process.env.SERVER) return;
      if (isEqual(this.lastConfig, config)) return; // 避免重复修改

      this.lastConfig = config;
      var self = this;
      var finalConfig = merge({
        code: code,
        link: link,
        group_id: 89541,
        css: {
          display: 'none'
        },
        customer: {},
        panel: {
          css: this.panelStyle,
          onToggle: function onToggle(_ref) {
            var visible = _ref.visible;

            // 不默认打开聊天面板
            if (visible && !self.isShow) {
              self.hide();
            }

            if (!visible) {
              self.isShow = false;
            }

            self.emit('toggle', visible);
          }
        },
        onUnread: function onUnread(_ref2) {
          var count = _ref2.count;
          self.unread = count;
          self.emit('onunread', count);
        }
      }, config);

      if (finalConfig.customer && finalConfig.customer.web_token) {
        var customer = _objectSpread({}, config.customer);

        var timestamp = Date.now();
        var nonce = this.getNonce(14); // signature 固定格式

        var signature = sha1("nonce=".concat(nonce, "&timestamp=").concat(timestamp, "&web_token=").concat(customer.web_token, "&").concat(imUserKey)).toString().toUpperCase();
        customer.nonce = nonce;
        customer.timestamp = timestamp;
        customer.signature = signature;
        finalConfig.customer = customer;
      }

      this.config = finalConfig;
      onWindowLoad().then(function () {
        return _this2.runUdeskScript();
      });
    }
  }, {
    key: "runUdeskScript",
    value: function runUdeskScript() {
      if (window.ud) {
        var udeskIframe = document.getElementById('udesk_iframe');

        if (udeskIframe && !this.__firstSetIframeSrc) {
          this.__firstSetIframeSrc = true;
          /**
           * 为什么特意对iframe.src处理
           * 原因： 重新修改udesk配置的时候，udesk内部会修改iframe的地址，会使浏览器的历史记录存入了udesk的更变地址，从而导致浏览器回退不正常
           * 要想要避免被存入浏览记录，那么在设置iframe的src的时候， iframe不能存在于dom树上， 而且udesk脚本，内部持有这个iframe
           * 所以不可以通过新建iframe的方式， 那么就让udesk在修改src前先让iframe脱离dom， 修改完后再插入dom中
           */

          Object.defineProperty(udeskIframe, 'src', {
            configurable: true,
            set: function set(value) {
              var parentElement = udeskIframe.parentElement;
              udeskIframe.setAttribute('src', value);
              parentElement.appendChild(udeskIframe);
            },
            get: function get() {
              return udeskIframe.attributes.src;
            }
          });
        }
      }

      if (!window.ud) {
        (function (a, h, c, b, f, g) {
          a['UdeskApiObject'] = f;

          a[f] = a[f] || function () {
            (a[f].d = a[f].d || []).push(arguments);
          };

          g = h.createElement(c);
          g.async = 1;
          g.charset = 'utf8';
          g.src = b;
          c = h.getElementsByTagName(c)[0];
          c.parentNode.insertBefore(g, c);
        })(window, document, 'script', '//assetscli.udesk.cn/im_client/js/udeskApi.js', 'ud');
      }

      window.ud(this.config);

      if (this.config.panel && this.config.panel.css) {
        this.setPanelStyle(this.config.panel.css);
      }

      this.wachUdeskLabel();
    }
  }, {
    key: "setPanelStyle",
    value: function setPanelStyle(style) {
      var panel = document.getElementById('udesk_panel');

      if (panel) {
        Object.keys(style).forEach(function (k) {
          panel.style[k] = style[k];
        });
      }
    }
    /**
     * 显示聊天面板
     *
     * @memberof Udesk
     */

  }, {
    key: "show",
    value: function show(config) {
      if (!window.ud) return;

      if (config) {
        this._setConfig(config);
      }

      if (this.firstShow) {
        if (!this.config) throw new Error('udesk 没有配置， 请执行 setConfig 配置');
        window.ud(this.config);
        this.firstShow = false;
      }

      this.isShow = true;
      this.unread = 0;
      this.emit('onunread', 0);
      window.ud.showPanel();
    }
    /**
     * 隐藏聊天面板
     */

  }, {
    key: "hide",
    value: function hide() {
      if (window.ud) window.ud.hidePanel();
    }
    /**
     * 开关切换
     */

  }, {
    key: "toggle",
    value: function toggle() {
      this.isShow ? this.hide() : this.show();
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      this.btn = document.getElementById('udesk_btn');

      if (this.btn) {
        this.btn.style.display = 'none';
        var label = this.label;
        this.label = document.getElementById('udesk_btn_text').innerHTML;

        if (this.label !== label) {
          this.emit('onlabel', this.label);
        }
      }
    }
  }, {
    key: "wachUdeskLabel",
    value: function wachUdeskLabel() {
      var _this3 = this;

      this.timer = setTimeout(function () {
        _this3.getLabel();

        _this3.wachUdeskLabel();
      }, 1000);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      clearTimeout(this.timer);
    }
  }]);

  return Udesk;
}(Event);

export default new Udesk();